export const AUTO_OPTIMIZED_CAMPAIGN_BUDGET = 'autoOptimizedCampaignBudget'

// IS INTERNAL AD
export const IS_QUARANTINE = 'quarantine'
